export const GOOGLE_MAPS_API_KEY = 'AIzaSyAJ5xOLytZDDRdeLzkZOKWrXiyKhkOVKfU';
